<!-- 成功页面 -->
<template>
  <cc-container>
    <cc-header-nav title="提交成功"></cc-header-nav>
    <cc-main>
      <div class="order_success_wrap">
        <div class="order_top">
          <div class="order_img">
            <img src="~assets/img/success.png" >
          </div>
          <div class="order_text">
            <p class="success_big">恭喜您，采购计划提交成功</p>
            <span  class="success_small">计划单号：{{this.$route.query.id}}</span>
          </div>
        </div>
        <div class="order_bottom">
          <router-link to="/purchase/history">返回采购计划列表</router-link>
          <router-link to="/purchase/product-stocks">继续提交采购计划</router-link>
        </div>
      </div>
    </cc-main>
  </cc-container>
</template>

<script>
export default {
  components: {},

  data () {
    return {
    }
  },

  computed: {},

  created () {
  },

  methods: {}
}

</script>
<style lang='scss' scoped>
.cc-main{
  background: #fff;
  .order_success_wrap{
    background: #fff;
    font-family: "黑体";
    width: 100%;
    height: auto;
    margin: 0 auto;
    max-width: 640px;
    .order_top{
      height: 170px;
      width: 320px;
      margin: 0 auto;
      .order_img{
        float: left;
        height: 100px;
        margin: 50px 18px;
        line-height: 100px;
        img{
          height: 100%;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .order_text{
        float: left;
        width: 60%;
        margin-top: 70px;
        color: #ff8c00;
        .success_big{
          font-size: 16px;
          margin-bottom: 16px;;
        }
        .success_small{
          font-size: 12px;
        }
      }
    }
    .order_bottom{
      text-align: center;
      width: 100%;
      display: flex;
      justify-content: center;
      a{
        font-size: 12px;
        display: block;
        padding: 9px 18px;
        border-radius: 5px;
        margin: 5px;
        color: var(--APP_theme_color);
        border: 1px solid var(--APP_theme_color)
      }
    }

  }
}
</style>
